import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { ExternalLink, Clock, Check, CircleDot } from "lucide-react";

const STATUS_META = {
  open: { label: "Em andamento", color: "text-accent-orange", bg: "bg-accent-orange/10", border: "border-accent-orange/30" },
  in_progress: { label: "Em produção", color: "text-blue-400", bg: "bg-blue-500/10", border: "border-blue-500/30" },
  review: { label: "Em revisão", color: "text-purple-400", bg: "bg-purple-500/10", border: "border-purple-500/30" },
  done: { label: "Entregue", color: "text-green-400", bg: "bg-green-500/10", border: "border-green-500/30" },
  cancelled: { label: "Cancelada", color: "text-neutral-500", bg: "bg-neutral-500/10", border: "border-neutral-500/30" },
};

export default function Demandas() {
  const [demands, setDemands] = useState([]);
  const [tab, setTab] = useState("all");

  const load = () => {
    const params = {};
    if (tab === "open") params.status = "open";
    if (tab === "done") params.status = "done";
    clientApi.get("/demands", { params }).then(({ data }) => setDemands(data));
  };

  useEffect(() => { load(); }, [tab]);

  return (
    <div className="space-y-6" data-testid="cliente-demandas-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Demandas</div>
        <h1 className="font-display text-3xl md:text-4xl">Suas solicitações</h1>
        <p className="text-sm text-neutral-400 mt-2">Todas as demandas enviadas via botão DEMANDAR — em andamento e entregues.</p>
      </div>

      <div className="flex gap-2" data-testid="demandas-tabs">
        {[
          { k: "all", label: "Todas" },
          { k: "open", label: "Em pauta" },
          { k: "done", label: "Entregues" },
        ].map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)} data-testid={`demandas-tab-${t.k}`}
            className={`px-4 py-2 text-xs rounded-full font-semibold transition ${tab === t.k ? "bg-accent-orange text-black" : "border border-white/10 hover:bg-white/5"}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {demands.map((d) => {
          const meta = STATUS_META[d.status] || STATUS_META.open;
          return (
            <div key={d.id} className={`border ${meta.border} rounded-xl p-5 ${meta.bg}`} data-testid={`demanda-${d.id}`}>
              <div className="flex justify-between items-start gap-4 flex-wrap">
                <div className="flex-1 min-w-[240px]">
                  <div className="flex items-center gap-2 mb-1">
                    <CircleDot className={`w-4 h-4 ${meta.color}`} />
                    <span className={`text-[10px] uppercase tracking-widest font-bold ${meta.color}`}>{meta.label}</span>
                  </div>
                  <div className="font-display text-xl">{d.piece_type} <span className="text-neutral-500 text-sm font-sans">· {d.department} / {d.work_front}</span></div>
                  {d.objectives && <div className="mt-2 text-sm text-neutral-300">🎯 {d.objectives}</div>}
                  {d.description && <div className="mt-1 text-sm text-neutral-400 line-clamp-2">{d.description}</div>}
                </div>
                <div className="text-right text-xs text-neutral-500 space-y-1">
                  <div className="flex items-center gap-1 justify-end"><Clock className="w-3 h-3" /> {new Date(d.created_at).toLocaleDateString("pt-BR")}</div>
                  {d.desired_deadline && <div>Prazo: {new Date(d.desired_deadline).toLocaleDateString("pt-BR")}</div>}
                  {d.clickup_task_url && <a href={d.clickup_task_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-accent-orange hover:underline"><ExternalLink className="w-3 h-3" /> ClickUp</a>}
                </div>
              </div>
              {(d.budget || d.formats) && (
                <div className="mt-3 pt-3 border-t border-white/5 flex flex-wrap gap-x-4 gap-y-1 text-[11px]">
                  {d.formats && <span className="text-neutral-500">Formatos: <b className="text-white">{d.formats}</b></span>}
                  {d.budget && <span className="text-neutral-500">Budget: <b className="text-white">{d.budget}</b></span>}
                </div>
              )}
            </div>
          );
        })}
        {demands.length === 0 && <div className="text-sm text-neutral-500 border border-dashed border-white/10 rounded-xl p-10 text-center">Nenhuma demanda no filtro atual. Use o botão <b className="text-accent-orange">DEMANDAR</b> na lateral para começar.</div>}
      </div>
    </div>
  );
}
